import { connect } from "react-redux";

import { requestChangePassword } from "../../../store/authentication/thunks";
import {
  setFailureMessage,
  logoutSuccessful
} from "../../../store/authentication/actions";
import ChangePassword from "./ChangePassword";
import { State } from "../../../store/state";

const mapStateToProps = (state: State) => ({
  user: state.authentication.user,
  failureMessage: state.authentication.failureMessage,
  initiatePasswordChange: state.authentication.initiatePasswordChange
});

const mapDispatchToProps = {
  logoutSuccessful,
  requestChangePassword,
  setFailureMessage
};

const ChangePasswordContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);

export default ChangePasswordContainer;
